declare var jQuery:any;

import React from 'react';
import ReactDom, {render} from 'react-dom';
import { Ajax } from "../actions/request";

import {ProductHeader} from "../props/product_header";
import {ProductFooter} from "../props/product_footer";
import {ProductFilter} from "../props/ProductFilter";
import {CalendarFilter} from "../props/calendarFilter";
import {ProductCard} from "../components/ProductCard";

declare var product_page_localize:any;
declare var adminSettings:any;
declare var SMSCALENDAR:any;

import "../../../css/main.css";
import { MinCartHandler } from '../actions/min_cart';

interface filterpriceObj {
    min_price:number,
    max_price:number
}

interface productFilterObj {
    filter_price:filterpriceObj,
    filter_cat:any
}

interface navObj {
    min_page:number,
    max_page:number,
    curr_page:number,
    total_pages:number,
    total_products:number,
    per_page:number,
}

interface payloadObj {
    product_total:number,
    product_list:Array<any>,
    page_nav:navObj,
    success:boolean,
    product_filter:productFilterObj,
}

interface objectTerm {
    taxonomy:string,
    term:string,
    checked:boolean
}

interface objectKey {
    [key:string]:any
}

const debounce = (callback:any, delay:any) =>{
    let timer:any;
    return (...args:any) =>{
        clearTimeout(timer);
        timer = setTimeout(() => callback(...args), delay);
    }
}

export class ProductList extends React.Component<any, any> {
    private ajax:Ajax;

    private curr_page:number=0;
    private min_page:number=0;
    private max_page:number=0;

    private req_type:string  = '';
    private min_value:number = 0;
    private max_value:number = 0;
    private search_q:string  = "";
    private filter_s:objectKey={};
    private minCart:MinCartHandler;

    private calendar:any;

    public state:any = {response: null, block:false, show_loader:false, can_go_bw:false, can_go_fw:false, max_page:0, min_page:0 };
    public action = 'request_product_listing';

    constructor(props:any) {
        super(props);
        this.state = {response: null, block: localStorage.getItem('display_type') ?? false, show_loader:false  };
        this.ajax = new Ajax();
        this.minCart = new MinCartHandler();
        window.addEventListener('cart_refreshed', (e:any) => {
            this.productRequest();
         }, false);

         this.state = {response: null, block: localStorage.getItem('display_type') ?? false, show_loader: false};
    }

    componentDidMount() {
        this.initialization();
    }

    initialization() {
        if(product_page_localize.product_type == 'calendar'){
            this.calendar = new SMSCALENDAR.MainClass();
            this.ajax.restartData();
            this.calendar.init();
            this.handleBlockTypeOnChange();
        }else{
            this.ajax.restartData();
            this.ajax.setData('product_type', product_page_localize.product_type);
            this.ajax.setData('curr_page', 1);
            this.ajax.setData('req_type', 'pre_load');
            this.ajax.callWPAjax(this.action, (response: payloadObj) => {
                this.setState({response: response});

                if (response.hasOwnProperty('page_nav') && response.page_nav) {
                    this.min_page = response.page_nav.min_page;
                    this.max_page = response.page_nav.max_page;

                    if (response.page_nav.hasOwnProperty('curr_page')) {
                        this.curr_page = response.page_nav.curr_page;
                    }

                    this.setState({max_page: response.page_nav.max_page, min_page: response.page_nav.min_page});
                    this.setState({can_go_fw: response.page_nav.curr_page < response.page_nav.max_page});
                    this.setState({can_go_bw: response.page_nav.curr_page > response.page_nav.min_page});
                }

                if (response.product_filter) {
                    this.min_value = response.product_filter.filter_price.min_price;
                    this.max_value = response.product_filter.filter_price.max_price;
                    this.req_type = response.product_filter.filter_cat;
                }
            });

            this.handleBlockTypeOnChange(false);
        }
        
        this.minCart.init();
    }

    handleBlockType = (e: any) => {
        var blockEl = jQuery(e.target);
        var blockType = blockEl.data('display-type');
        this.setState({block: (blockType == 'block-type')});
        localStorage.setItem('display_type', blockType);
        this.handleBlockTypeOnChange();
    }

    handleBlockTypeOnChange = (newRequest = true) => {
        var display_type = localStorage.getItem('display_type');
        if (display_type) {
            this.setState({block: display_type});
            if(newRequest){
                this.productRequest();
            }
        }
    }

    productRequest = ( config:any={} ) => {
        if( product_page_localize.product_type == 'calendar' ) {
            if(this.search_q){
                this.ajax.restartData();
                let start =  this.calendar.currentDateStart();
                let end =  this.calendar.currentDateEnd();
                this.calendar.get_data(this.search_q, start, end);
            }else{
                this.ajax.restartData();
                this.calendar.init();
            }
        }else{
            this.setState({ show_loader: true });
            this.ajax.restartData();
            this.ajax.setData('product_type', product_page_localize.product_type );
            this.ajax.setData('curr_page', this.curr_page >= 1 ? this.curr_page : 1);
            this.ajax.setData('req_type', 'nav');

            this.ajax.setData('price_min', this.min_value);
            this.ajax.setData('price_max', this.max_value);
            this.ajax.setData('search_q', this.search_q);
            this.ajax.setData('filter_s', this.filter_s);

            this.ajax.callWPAjax(this.action, (response: payloadObj) => {
                this.setState({response: response, show_loader: false});

                if ( response.hasOwnProperty('page_nav') && response.page_nav) {
                    this.min_page = response.page_nav.min_page;
                    this.max_page = response.page_nav.max_page;

                    if (response.page_nav.hasOwnProperty('curr_page')) {
                        this.curr_page = response.page_nav.curr_page;
                    }

                    this.setState({max_page: response.page_nav.max_page, min_page: response.page_nav.min_page});
                    this.setState({can_go_fw: response.page_nav.curr_page < response.page_nav.max_page});
                    this.setState({can_go_bw: response.page_nav.curr_page > response.page_nav.min_page});
                }
            });
        }
    }

    navHandler = (e: any) => {
        var navEl = jQuery(e.target);

        var currentState = this.state.response;
        if (!currentState) return;

        var __btn_type = navEl.data('nav-btn');

        if (__btn_type == "fw") {
            if (this.curr_page >= this.max_page) return;
        }

        if (__btn_type == "bw") {
            if (this.curr_page <= this.min_page) return;
        }

        if (__btn_type == "fw") {
            this.curr_page += 1;
        } else if (__btn_type == "bw") {
            this.curr_page -= 1;
        }

        if(this.curr_page <= 0){
            this.curr_page = 1;
        }

        var config = {}
        this.productRequest(config);
        this.handleBlockTypeOnChange(false);
    }

    onRangeChange = (e: any) => {
        var minValue = e.minValue;
        var maxValue = e.maxValue;

        this.min_value = minValue;
        this.max_value = maxValue;

        this.productRequest();
    }

    debounceLog = debounce((text:any) => {
        this.search_q = text;
        this.productRequest();
    }, 800);

    onSearchChange = (e:any) => {
        this.debounceLog(e);
    }

    navHandlerInput = (e: any) => {
        var currentState = this.state.response;
        if (!currentState) return;

        const newPage = e.target.value;

        if (newPage >= currentState.page_nav.min_page && newPage <= currentState.page_nav.max_page) {
            this.curr_page = newPage;

            var config = {}
            this.productRequest(config);
            this.handleBlockTypeOnChange();
        }

        return;
    }

    elExists = (tag_term: string, tag: string) => {
        var exists = {
            exist: false,
            index: -1
        }

        this.filter_s[tag_term].forEach((obj: any, index: number) => {
            if (obj.term == tag) {
                exists.exist = true;
                exists.index = index;
            }
        });

        return exists;
    }

    onFilterChecked = (e: any) => {
        const checked = e.target.checked;
        const tag = e.target.getAttribute('data-cat');
        const tag_term = e.target.getAttribute('data-cat-term');

        if (tag == 'all') {
            this.filter_s = {};

            var _inputs = document.querySelectorAll("input[data-cat]");
            _inputs.forEach((e: any, index: number) => {
                if (e.getAttribute('data-cat') !== 'all') {
                    e.checked = false;
                }
            });

            this.productRequest();
            return;
        }

        // if all selected then uncheck it
        var _all_option = document.querySelectorAll('input[data-cat="all"]');
        [].filter.call(_all_option, function (el: any) {
            if (el.checked) {
                el.checked = false;
            }
        });

        if (this.filter_s[tag_term] == undefined) {
            this.filter_s[tag_term] = []; // declare
        }

        var tagExists = this.elExists(tag_term, tag);

        if (tagExists.exist) {
            this.filter_s[tag_term][tagExists.index].checked = checked;
        } else {
            this.filter_s[tag_term].push({
                taxonomy: tag_term,
                term: tag,
                checked: checked
            });
        }

        // check if other filters are checked :: if not check _all option on default
        var _all_checked = true;
        Object.keys(this.filter_s).map((key:any) => {
            this.filter_s[key].forEach((data:any) => {
                if( data.checked ) {
                    _all_checked = false;
                }
            });
        });

        // if( !_all_checked ) {
        // check the all selector
        var _all_option = document.querySelectorAll('input[data-cat="all"]');
        [].filter.call(_all_option, function (el: any) {
            el.checked = _all_checked;
        });
        // }

        this.productRequest();
    }

    render() {
        var product_data = this.state.response;

        return (<>
            <div dangerouslySetInnerHTML={{__html: product_page_localize.wc_notices}}></div>
            <div className="product--content-wrapper">
                <div className='product--list'>

                    <ProductHeader blockHandler={this.handleBlockType} blockType={this.state.block}/>

                    {this.state.show_loader ?
                        <div className='product--inline-wrapper'>
                            <div className="product--inline-loader"></div>
                        </div>
                        : null
                    }

                    {!this.state.show_loader ?
                        <div className="product--list-items">
                            {product_data != null && product_data.success ?
                                product_data.product_total > 0 ?
                                    <>
                                        {product_data.product_list.map((product: any, index: number) => (
                                            <ProductCard key={"prod_card_" + product.product_id}
                                                         layout={this.state.block} data={product}/>
                                        ))}
                                    </>
                                    : null
                                : <div className='product--inline-wrapper'>
                                    <div className="product--inline-loader"></div>
                                </div>
                            }
                        </div>
                        : null
                    }

                    <ProductFooter
                        navHandlerInput={this.navHandlerInput}
                        navHandler={this.navHandler}
                        curr_user={0}
                        product_data={product_data}
                        canGoBW={this.state.can_go_bw}
                        canGoFW={this.state.can_go_fw}
                    />
                </div>

                <div>
                    {
                        product_page_localize.product_type == 'calendar' ?
                            <CalendarFilter onChecked={this.onFilterChecked} product_data={product_data}
                                onSearch={this.onSearchChange} onRangeChange={this.onRangeChange} />
                        : product_data != null ?
                            <ProductFilter onChecked={this.onFilterChecked} product_data={product_data}
                                onSearch={this.onSearchChange} onRangeChange={this.onRangeChange} />
                        : null
                    }
                </div>
            </div>
        </>)
    }
}
